import CRUD from './genericCRUD'

const route = 'countries'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function countries(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''

			return instance.get(`${route}?${params}${nameParam}`, config)
		}
	}
}
